<template>
  <div class="feedback">
    <transition name="fade" @enter="enterFeedback">
      <Feedback
        v-if="showableFeedback"
        :feedback-class="feedbackClass"
        :message="message"
      />
    </transition>
  </div>
</template>

<script setup>
import Feedback from '../../atoms/feedbacks/feedback.vue'
import { computed, onMounted, ref } from 'vue'

const props = defineProps({
  message: {
    type: String,
    required: true
  },
  timeout: {
    type: Number,
    required: false,
    default: 3000
  },
  type: {
    type: String,
    required: true
  }
})

const feedbackClass = computed(() => {
  switch (props.type) {
    case 'error':
      return 'feedback--error'
    case 'success':
      return 'feedback--success'
    default:
      return 'feedback--success'
  }
})

const showableFeedback = ref(false)
const enterFeedback = () => {
  setTimeout(() => {
    showableFeedback.value = false
  }, props.timeout)
}

onMounted(() => {
  // メッセージが存在したら表示する
  showableFeedback.value = !!props.message
})
</script>

<style lang="scss" scoped>
.feedback {
  color: $white;
  font-size: 1.4rem;
  line-height: 1.6;
  border-radius: 8px;
  text-align: center;
  width: 100%;
  max-width: $pc-width;
  padding: 0;

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .feedback--success,
  .feedback--error {
    width: calc(100vw - 4.17vw);
    max-width: 840px;
    position: fixed;
    z-index: 200;
    left: 50%;
    top: 24px;
    transform: translate(-50%, 0);

    @media screen and (max-width: $small-contents-width) {
      width: calc(100vw - 8.53vw);
      max-width: 343px;
    }
  }
}
</style>
